export default "__VITE_ASSET__DSt4w3uN__"